import React from 'react';
const Tier40 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        className: className,
        width: "14",
        height: "13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        d: "M13.834 4.501l-1.487 7.417a.6.6 0 01-.588.482H2.242a.6.6 0 01-.588-.482L.166 4.5a.4.4 0 01.58-.431L4.376 6l2.262-4.827a.4.4 0 01.724 0L9.625 6l3.629-1.93a.4.4 0 01.58.431z"
    }));
Tier40.displayName = 'Tier40';
export default Tier40;
